/* FUT7 — gaveta do cesto nativa. Ver snippets/f7-cart.liquid. Sem bibliotecas. */
(function(){
  'use strict';
  if (window.F7Cart) return;
  var dataEl = document.getElementById('f7-ct-data');
  if (!dataEl) return;
  var CFG;
  try { CFG = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var T = CFG.text || {};
  /* v16: Black November (window.F7BN, snippets/f7-bn): 12 camisolas 3 | 7 | 12, cupão BLACK10 e sugestões para completar o pack.
     O desconto continua a ser calculado pela Shopify; a gaveta só lê o cart.js e mostra. A 1/12 o F7BN deixa de existir. */
  var BN = window.F7BN || null, B = BN ? BN.t : {};
  var prevN = null, upsell = null;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART_PATH = /^(\/[a-z]{2}(-[a-z0-9]{2,4})?)?\/cart\/?$/i;
  var el = null, panel = null, cart = null, lastFocus = null, prevKeys = null, lastSig = null, MAP = null, seq = 0;
  var queue = Promise.resolve();

  var $ = function(s){ return el.querySelector(s); };
  var esc = function(t){ return String(t == null ? '' : t).replace(/[&<>"']/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  /* Substitui {chave}; os valores já vêm em HTML seguro */
  var fillHtml = function(tpl, o){ return esc(tpl || '').replace(/\{(\w+)\}/g, function(_, k){ return o[k] != null ? o[k] : ''; }); };
  var fill = function(tpl, o){ return String(tpl || '').replace(/\{(\w+)\}/g, function(_, k){ return o[k] != null ? o[k] : ''; }); };

  /* ---------- Dinheiro: formato da loja; noutra moeda (mercados) usa a amostra {{ 123456 | money }} ---------- */
  var decode = function(s){ var t = document.createElement('textarea'); t.innerHTML = String(s || '').replace(/<[^>]*>/g, ''); return t.value; };
  var TABLE = {
    amount: [',', '.', 2], amount_no_decimals: [',', '.', 0],
    amount_with_comma_separator: ['.', ',', 2], amount_no_decimals_with_comma_separator: ['.', ',', 0],
    amount_with_apostrophe_separator: ["'", '.', 2], amount_no_decimals_with_space_separator: [' ', ',', 0],
    amount_with_space_separator: [' ', ',', 2], amount_with_period_and_space_separator: [' ', '.', 2]
  };
  var fromFormat = function(fmt){
    fmt = decode(fmt);
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return null;
    var r = TABLE[m[1]] || TABLE.amount;
    return { pre: fmt.slice(0, m.index), suf: fmt.slice(m.index + m[0].length), th: r[0], dec: r[1], dp: r[2] };
  };
  var fromSample = function(s){
    s = decode(s);
    var m = s.match(/\d[\d.,'\s  ]*\d|\d/);
    if (!m) return null;
    var run = m[0], seps = run.replace(/\d/g, ''), last = seps.charAt(seps.length - 1), f = { pre: s.slice(0, m.index), suf: s.slice(m.index + run.length), th: '', dec: '.', dp: 0 };
    if (last) {
      var tail = run.slice(run.lastIndexOf(last) + 1);
      if (tail.length === 2) { f.dp = 2; f.dec = last; f.th = seps.length > 1 ? seps.charAt(0) : ''; }
      else f.th = last;
    }
    return f;
  };
  var F_SHOP = fromFormat(CFG.money), F_SAMPLE = fromSample(CFG.sample);
  var money = function(cents){
    var f = (cart && cart.currency && CFG.currency && cart.currency !== CFG.currency ? F_SAMPLE : F_SHOP) || F_SAMPLE || { pre: '€', suf: '', th: '.', dec: ',', dp: 2 };
    var parts = (Math.round(cents || 0) / 100).toFixed(f.dp).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.th);
    return f.pre + parts.join(f.dec) + f.suf;
  };

  /* ---------- Nome do clube só por código (mapa [data-f7-clubes]; pt: n, outros: ne) ---------- */
  var teamName = function(handle){
    if (!MAP) {
      var d = document.querySelector('[data-f7-clubes]');
      if (!d) return '';
      var pt = /^pt/i.test(document.documentElement.lang || ''), m = {};
      try { JSON.parse(d.textContent).forEach(function(c){ if (c && c.c && !m[c.c]) m[c.c] = pt ? c.n : (c.ne || c.n); }); } catch (e) {}
      MAP = m;
    }
    var p = String(handle || '').split('-');
    for (var i = p.length - 1; i >= 0; i--) { if (/^\d{3}$/.test(p[i]) && MAP[p[i]]) return MAP[p[i]]; }
    return '';
  };

  var allocs = function(it){ var a = it.line_level_discount_allocations; return (a && a.length ? a : (it.discounts || [])).filter(function(d){ return d.amount > 0; }); };
  /* Nome do desconto no idioma da página: os descontos automáticos só têm um título (PT); a chave são os números
     da oferta ("2 3", "3 7", "5 10"). Sem tradução, fica o título do desconto. */
  var DN = T.discNames || {};
  var trDisc = function(t){ var k = String(t || '').replace(/[^0-9]+/g, ' ').trim(); return (k && DN[k]) || t; };
  var dtitle = function(d){ return trDisc(String((d.discount_application && d.discount_application.title) || d.title || '').trim()); };
  var counted = function(it){ return String(it.handle || '').indexOf(CFG.exclude || 'mystery-box') < 0; };
  var freeOf = function(n){ return BN ? BN.freeOf(n) : n >= 10 ? 5 : n >= 7 ? 4 : Math.floor(n / 3); };
  var countedN = function(){ return cart ? cart.items.reduce(function(s, it){ return s + (counted(it) ? it.quantity : 0); }, 0) : 0; };
  var SHIRT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 3.5L3 6l1.6 4 2.4-1V21h10V9l2.4 1L21 6l-5-2.5c-.6 1.6-2.2 2.6-4 2.6s-3.4-1-4-2.6z"/></svg>';
  var ICO = {
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 10h16v11H4zM2 7h20v3H2zM12 7v14M12 7c-1-3-5-4-5-1.5S12 7 12 7zm0 0c1-3 5-4 5-1.5S12 7 12 7z"/></svg>',
    trash: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>',
    minus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12h12"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 6v12M6 12h12"/></svg>'
  };

  /* ---------- Black November: barra com 12 camisolas, degraus e aviso ao desbloquear ---------- */
  var ICO_BN = {
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    tag: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12V4h8l10 10-8 8L3 12z"/><circle cx="7.5" cy="8.5" r="1.5"/></svg>'
  };
  var cdLeft = function(){ var ms = Math.max(0, Date.parse(BN.end) - Date.now()); return { d: Math.floor(ms / 864e5), h: ('0' + (Math.floor(ms / 36e5) % 24)).slice(-2) }; };
  var renderBarBN = function(n){
    var bar = $('.f7-ct-bar'), fr = freeOf(n), next = BN.next(n), st = BN.slots(Math.min(n, 12)), reached = null;
    BN.tiers.forEach(function(t){ if (n >= t.at) reached = t; });
    var sh = n === 1 ? T.shirtOne : T.shirtOther, title, sub;
    if (!n) { title = esc(B.cart_t0); sub = esc(B.cart_s0); }
    else {
      title = fill(fr ? B.cart_head : B.cart_head0, { n: n, shirts: esc(sh), free: fr });
      sub = next ? fill(B.cart_next, { x: next.at - n, free: next.free }) + ' <span class="bnc-goal">(' + esc(next.name.toLowerCase()) + ')</span>' : (n === 12 ? B.cart_full : esc(B.cart_full_more));
    }
    var slots = '';
    st.forEach(function(cls, i){
      var k = i + 1, tier = null;
      BN.tiers.forEach(function(t){ if (t.at === k) tier = t; });
      var pop = prevN !== null && k > prevN && k <= n ? ' is-pop' : '';
      slots += '<span class="f7-ct-slot ' + cls + pop + (!cls && tier ? ' is-goal' : '') + '" style="--d:' + Math.max(0, (k - (prevN || 0)) * 60) + 'ms">' + SHIRT + '<small>' + (tier ? '+' + tier.free : '') + '</small></span>';
      if (k === 3 || k === 7) slots += '<span class="f7-ct-sep"></span>';
    });
    var steps = BN.tiers.map(function(t){ return '<span class="' + (n >= t.at ? 'is-on' : '') + (reached === t ? ' is-cur' : '') + '">' + (n >= t.at ? ICO_BN.check : '') + esc(t.name) + '</span>'; }).join('');
    var win = prevN !== null && reached && prevN < reached.at;
    bar.classList.add('bnc-pack');
    bar.classList.toggle('is-win', !!win);
    bar.innerHTML = '<div class="bnc-pack__top"><span class="bnc-pack__k">' + esc(B.tb_title) + '</span><span class="bnc-pack__cd">' + esc(fill(B.cart_ends, cdLeft())) + '</span></div>' +
      '<div class="f7-ct-bar-text" role="status" aria-live="polite"><p class="f7-ct-bar-title">' + title + '</p><p class="f7-ct-bar-sub">' + sub + '</p></div>' +
      '<div class="f7-ct-slots bnc-slots" aria-hidden="true">' + slots + '</div>' +
      '<div class="bnc-steps" aria-hidden="true">' + steps + '</div>' +
      (win ? '<div class="bnc-win">' + ICO.gift + '<span>' + fill(B.cart_win, { tier: esc(reached.name.toLowerCase()) }) + '</span></div>' : '');
    prevN = n;
  };

  /* Cupão BLACK10: falta X / Aplicar / aplicado. O mínimo (€150) é o subtotal depois das camisolas grátis, na moeda do cesto. */
  var rate = function(){ var c = window.Shopify && Shopify.currency; return c && c.active && c.active !== CFG.currency ? (parseFloat(c.rate) || 1) : 1; };
  var myCode = function(){ var m = null; ((cart && cart.discount_codes) || []).forEach(function(d){ if (String(d.code || '').toUpperCase() === BN.code) m = d; }); return m; };
  var renderCoupon = function(){
    var box = $('[data-f7-bn-cp]'); if (!box) return;
    if (!countedN()) { box.innerHTML = ''; return; }
    var mine = myCode(), min = Math.round(BN.min * rate()), sub = cart.items_subtotal_price || 0;
    if (mine && mine.applicable) {
      box.innerHTML = '<div class="bnc-cp is-on">' + ICO_BN.check + '<span>' + B.cp_on + '</span><button type="button" data-f7-bn-cp="0">' + esc(B.cp_remove) + '</button></div>';
    } else if (sub < min) {
      var pct = Math.min(100, Math.round(sub / min * 100));
      box.innerHTML = '<div class="bnc-cp is-wait">' + ICO_BN.tag + '<div><span>' + fill(B.cp_wait, { x: esc(money(min - sub)) }) + '</span><i class="bnc-cp__bar"><i style="width:' + pct + '%"></i></i></div>' +
        (mine ? '<button type="button" data-f7-bn-cp="0">' + esc(B.cp_remove) + '</button>' : '') + '</div>';
    } else {
      box.innerHTML = '<div class="bnc-cp is-ready">' + ICO_BN.tag + '<span>' + B.cp_ready + '</span><button type="button" data-f7-bn-cp="1">' + esc(B.cp_apply) + '</button></div>';
    }
  };
  var toast = function(msg){
    if (!msg) return;
    var t = document.querySelector('.bn-toast');
    if (!t) { t = document.createElement('div'); t.className = 'bn-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.remove('is-on'); void t.offsetWidth; t.classList.add('is-on');
    clearTimeout(t._t); t._t = setTimeout(function(){ t.classList.remove('is-on'); }, 2800);
  };
  var setCode = function(on){
    queue = queue.then(function(){
      ++seq;
      return fetch(ROOT + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: on ? BN.code : '' }) })
        .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
        .then(function(){ return refresh(); })
        .then(function(){ var m = myCode(), ok = !!(m && m.applicable); if (on && !ok) showError(B.cp_error); toast(on ? (ok ? B.toast_on : '') : B.toast_off); })
        .catch(function(){ showError(B.cp_error); return refresh().catch(function(){}); });
    });
    return queue;
  };

  /* "Junta mais X para paga 5 leva 12": camisolas da nova época (coleção 900), um toque no tamanho junta ao cesto */
  var loadUpsell = function(){
    if (upsell) return;
    upsell = [];
    fetch(ROOT + 'collections/900/products.json?limit=24', { credentials: 'same-origin' }).then(function(r){ return r.json(); }).then(function(d){
      upsell = (d.products || []).filter(function(p){ return p.variants && p.variants.length && /shirt/.test(p.handle) && p.variants.some(function(v){ return v.available; }); });
      renderUpsell();
    }).catch(function(){});
  };
  var renderUpsell = function(){
    var box = $('[data-f7-bn-up]'); if (!box || !cart) return;
    var n = countedN(), next = BN.next(n), inCart = {};
    cart.items.forEach(function(i){ inCart[i.handle] = 1; });
    var list = (upsell || []).filter(function(p){ return !inCart[p.handle]; }).slice(0, 10);
    if (!upsell || (upsell.length && !list.length)) { box.innerHTML = ''; return; }
    var title = !n ? B.up_start : next ? fill(B.up_next, { x: next.at - n, tier: next.name.toLowerCase() }) : B.up_more;
    var cards = upsell.length ? list.map(function(p){
      var name = teamName(p.handle), pt = String(p.title || ''), tt = name && pt.indexOf(name) < 0 ? name + ' ' + pt : pt;
      var img = (p.images && p.images[0] && p.images[0].src) || '';
      var sizes = p.variants.filter(function(v){ return v.available; }).slice(0, 6);
      return '<div class="bnc-uc"><a class="bnc-uc__img" href="' + esc(ROOT + 'products/' + p.handle) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=280" alt="" loading="lazy" width="138" height="138">' : '') + '</a>' +
        '<b class="bnc-uc__t">' + esc(tt) + '</b><span class="bnc-uc__p">' + esc(money(Math.round(parseFloat(p.variants[0].price) * 100))) + '</span>' +
        '<div class="bnc-uc__s">' + sizes.map(function(v){ return '<button type="button" data-f7-bn-add="' + v.id + '" aria-label="' + esc(tt + ' · ' + v.title) + '">' + esc(v.option1 || v.title) + '</button>'; }).join('') + '</div></div>';
    }).join('') : '<div class="bnc-uc is-skel"></div><div class="bnc-uc is-skel"></div><div class="bnc-uc is-skel"></div>';
    box.innerHTML = '<section class="bnc-up"><div class="bnc-up__h"><b>' + esc(title) + '</b><span>' + esc(B.up_hint) + '</span></div><div class="bnc-up__row">' + cards + '</div></section>';
  };
  var addVariant = function(id, btn){
    if (btn) btn.classList.add('is-on');
    queue = queue.then(function(){
      ++seq;
      return fetch(ROOT + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
        .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
        .then(function(){ return refresh(); })
        .catch(function(j){ showError(j && (j.description || j.message)); return refresh().catch(function(){}); });
    });
    return queue;
  };

  /* ---------- Barra da oferta: 7 camisolas (pagas a preto, grátis a laranja), divisória depois da 3.ª ---------- */
  var renderBar = function(){
    var n = countedN();
    if (BN) return renderBarBN(n);
    var fr = freeOf(n), x = 0, y = 0;
    if (n < 3) { x = 3 - n; y = 1; } else if (n < 7) { x = 7 - n; y = 4 - fr; } else if (n < 10) { x = 10 - n; y = 1; }
    $('[data-f7-ct-bar-title]').innerHTML = esc(fill(T.barTitle, { n: n, shirts: n === 1 ? T.shirtOne : T.shirtOther })) +
      ' · <b>' + esc(fill(T.barFree, { free: fr })) + '</b>';
    $('[data-f7-ct-bar-sub]').innerHTML = n >= 10 ? '<b>' + esc(fill(T.barMax, { free: fr })) + '</b>' :
      fillHtml(T.barNext, { x: '<b>' + x + '</b>', y: '<b>' + y + '</b>' });
    var html = '', all7 = n >= 7;
    for (var i = 1; i <= 7; i++) {
      var cls = i <= n ? (all7 ? (i > 3 ? ' is-free' : ' is-paid') : (i % 3 === 0 ? ' is-free' : ' is-paid')) : '';
      var tag = i === 3 && !all7 ? '+1' : i === 7 ? '+4' : '';
      html += '<span class="f7-ct-slot' + cls + '">' + SHIRT + '<small>' + tag + '</small></span>';
      if (i === 3) html += '<span class="f7-ct-sep"></span>';
    }
    var slots = $('[data-f7-ct-slots]');
    if (slots.getAttribute('data-n') !== String(n)) { slots.innerHTML = html; slots.setAttribute('data-n', n); }
  };

  /* ---------- Linhas ---------- */
  var renderLines = function(){
    var keys = {}, first = prevKeys === null;
    $('[data-f7-ct-lines]').innerHTML = cart.items.map(function(it){
      var name = teamName(it.handle), pt = String(it.product_title || '');
      var title = name && pt.indexOf(name) < 0 ? name + ' ' + pt : pt;
      var meta = (it.options_with_values || []).filter(function(o){ return o.value && o.value !== 'Default Title'; }).map(function(o){
        var lbl = /^(size|tamanho|talla|taille|gr(o|ö)(ss|ß)e|taglia|maat|rozmiar|storlek|st(ø|o)rrelse|koko)$/i.test(o.name) ? T.size : o.name;
        return '<span>' + esc(lbl) + ': <b>' + esc(o.value) + '</b></span>';
      });
      Object.keys(it.properties || {}).forEach(function(k){
        var v = it.properties[k];
        if (k.charAt(0) === '_' || v == null || String(v).trim() === '') return;
        /* v10: só a etiqueta muda com o idioma; a chave da propriedade (Nome, Número, Badges) nunca muda */
        var kl = ({ 'Nome': T.p_name, 'Número': T.p_number, 'Badges': T.p_badges })[k] || k;
        meta.push('<span>' + esc(kl) + ': <b>' + esc(v) + '</b></span>');
      });
      var tags = [];
      allocs(it).forEach(function(d){ var t = dtitle(d); if (t && tags.indexOf(t) < 0) tags.push(t); });
      var tagHtml = tags.map(function(t){ return '<span class="f7-ct-tag">' + ICO.gift + '<span>' + esc(t) + '</span></span>'; }).join('');
      var now = it.final_line_price;
      var price = now === 0 && it.original_line_price > 0 ? '<span class="f7-ct-free">' + esc(T.free) + '</span>' : '<b>' + esc(money(now)) + '</b>';
      /* Black November: preço riscado e "Grátis" nas camisolas que saíram de graça, faixa "Grátis" na foto */
      var fu = 0;
      if (BN && it.original_price > 0) {
        fu = Math.min(it.quantity, Math.round(allocs(it).reduce(function(s, d){ return s + d.amount; }, 0) / it.original_price));
        if (fu) price = '<s>' + esc(money(it.original_line_price)) + '</s>' + (now === 0 ? '<span class="f7-ct-free">' + esc(T.free) + '</span>' : '<b>' + esc(money(now)) + '</b>');
        if (fu && fu < it.quantity) tagHtml += '<span class="f7-ct-tag">' + ICO.gift + '<span>' + esc(fill(B.free_units, { n: fu })) + '</span></span>';
      }
      var img = it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="60" height="60" loading="lazy">' : '';
      keys[it.key] = 1;
      return '<li class="f7-ct-line' + (!first && !prevKeys[it.key] ? ' is-new' : '') + '" data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '">' +
        '<a class="f7-ct-img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + img + (fu ? '<em class="bnc-free-dot">' + esc(T.free) + '</em>' : '') + '</a>' +
        '<div class="f7-ct-info">' +
          '<div class="f7-ct-top"><a class="f7-ct-name" href="' + esc(it.url) + '">' + esc(title) + '</a>' +
          '<button type="button" class="f7-ct-rm" data-f7-ct-rm aria-label="' + esc(T.remove + ': ' + title) + '">' + ICO.trash + '</button></div>' +
          (meta.length ? '<p class="f7-ct-meta">' + meta.join('') + '</p>' : '') +
          '<div class="f7-ct-bot"><div class="f7-ct-qty">' +
            '<button type="button" data-f7-ct-dec aria-label="' + esc(T.dec) + '">' + ICO.minus + '</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-f7-ct-inc aria-label="' + esc(T.inc) + '">' + ICO.plus + '</button></div>' +
          '<div class="f7-ct-price">' + tagHtml + price + '</div></div>' +
        '</div></li>';
    }).join('');
    prevKeys = keys;
  };

  var render = function(){
    if (!cart || !el) return;
    var count = cart.item_count || 0, empty = !count;
    $('[data-f7-ct-count]').textContent = count;
    renderBar();
    renderLines();
    $('[data-f7-ct-empty]').hidden = !empty;
    $('[data-f7-ct-foot]').hidden = empty;
    var disc = cart.total_discount || Math.max(0, (cart.original_total_price || 0) - (cart.total_price || 0));
    $('[data-f7-ct-sub-row]').hidden = $('[data-f7-ct-disc-row]').hidden = !disc;
    $('[data-f7-ct-sub]').textContent = money(cart.original_total_price);
    $('[data-f7-ct-disc]').textContent = '-' + money(disc);
    var names = (cart.cart_level_discount_applications || []).map(function(d){ return trDisc(String(d.title || '').trim()); }).filter(Boolean);
    cart.items.forEach(function(it){ allocs(it).forEach(function(d){ var t = dtitle(d); if (t && names.indexOf(t) < 0) names.push(t); }); });
    $('[data-f7-ct-disc-label]').textContent = names.length ? names.join(' + ') : T.discounts;
    $('[data-f7-ct-total]').textContent = money(cart.total_price);
    $('[data-f7-ct-checkout-total]').textContent = money(cart.total_price);
    if (BN) {
      var sv = $('[data-f7-bn-save]');
      if (sv) { sv.hidden = !disc; sv.textContent = fill(B.save, { x: money(disc) }); }
      renderCoupon();
      renderUpsell();
    }
  };

  /* ---------- Estado e avisos: cart:updated só quando o cesto mudou (abrir pelo ícone não limpa a personalização) ---------- */
  var sig = function(c){ return (c.item_count || 0) + '|' + c.total_price + '|' + (c.items || []).map(function(i){ return i.key + ':' + i.quantity; }).join(','); };
  var announce = function(){
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    if (typeof window.upcartOnCartUpdated === 'function') { try { window.upcartOnCartUpdated(cart); } catch (e) {} }
  };
  var setCart = function(c){
    cart = c; render();
    var s = sig(c);
    if (lastSig !== null && s !== lastSig) announce();
    lastSig = s;
    return c;
  };
  var refresh = function(){
    var my = ++seq;
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(c){ return my === seq ? setCart(c) : cart; });
  };
  var showError = function(msg){
    var e = $('[data-f7-ct-error]');
    e.textContent = msg || T.error; e.hidden = false;
    clearTimeout(e._t); e._t = setTimeout(function(){ e.hidden = true; }, 5000);
  };
  var change = function(key, qty){
    var line = el.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (line) line.classList.add('is-busy');
    queue = queue.then(function(){
      ++seq;
      return fetch(ROOT + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
        .then(setCart)
        .catch(function(j){ showError(j && (j.description || j.message)); return refresh().catch(function(){}); });
    });
    return queue;
  };

  /* ---------- Abrir / fechar ---------- */
  var doOpen = function(){
    if (!el || el.classList.contains('is-open')) return;
    if (BN) loadUpsell();
    lastFocus = lastFocus || document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('f7-ct-lock');
    setTimeout(function(){ try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); } }, 40);
  };
  var doClose = function(){
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('f7-ct-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    lastFocus = null;
  };
  var openFresh = function(){
    if (!el) return Promise.resolve(cart);
    return refresh().then(function(c){ doOpen(); return c; }, function(){ doOpen(); return cart; });
  };

  var setup = function(node){
    if (el) return;
    el = node; panel = $('.f7-ct-panel');
    if (BN) {
      var body = $('[data-f7-ct-body]');
      body.insertAdjacentHTML('afterbegin', '<div data-f7-bn-cp></div>');
      body.insertAdjacentHTML('beforeend', '<div data-f7-bn-up></div>');
      var et = $('.f7-ct-empty-text'); if (et) et.textContent = B.empty_text;
      var tl = $('.f7-ct-row--total span'); if (tl) tl.insertAdjacentHTML('beforeend', ' <em class="bnc-save" data-f7-bn-save hidden></em>');
      el.classList.add('f7-bn-cart');
      el.addEventListener('click', function(e){
        var cp = e.target.closest('button[data-f7-bn-cp]');
        if (cp) { e.preventDefault(); setCode(cp.getAttribute('data-f7-bn-cp') === '1'); return; }
        var ad = e.target.closest('[data-f7-bn-add]');
        if (ad) { e.preventDefault(); addVariant(ad.getAttribute('data-f7-bn-add'), ad); }
      });
    }
    /* Deslizar para a direita fecha a gaveta (telemóvel) */
    (function(){
      var x0 = null, y0 = 0, dx = 0, lock = null;
      panel.addEventListener('touchstart', function(e){ if (e.touches.length !== 1) return; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; lock = null; }, { passive: true });
      panel.addEventListener('touchmove', function(e){
        if (x0 == null) return;
        var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
        if (lock == null && (Math.abs(mx) > 8 || Math.abs(my) > 8)) lock = Math.abs(mx) > Math.abs(my) * 1.3 ? 'x' : 'y';
        if (lock !== 'x') return;
        dx = Math.max(0, mx);
        panel.classList.add('is-drag');
        panel.style.transform = 'translate3d(' + dx + 'px,0,0)';
      }, { passive: true });
      var end = function(){
        if (x0 == null) return;
        x0 = null; panel.classList.remove('is-drag'); panel.style.transform = '';
        if (lock === 'x' && dx > Math.min(110, panel.offsetWidth * .3)) doClose();
      };
      panel.addEventListener('touchend', end); panel.addEventListener('touchcancel', end);
    })();
    el.addEventListener('click', function(e){
      if (e.target.closest('[data-f7-ct-close]')) { e.preventDefault(); doClose(); return; }
      var line = e.target.closest('[data-key]'); if (!line) return;
      var key = line.getAttribute('data-key'), q = +line.getAttribute('data-qty');
      if (e.target.closest('[data-f7-ct-rm]')) change(key, 0);
      else if (e.target.closest('[data-f7-ct-inc]')) change(key, q + 1);
      else if (e.target.closest('[data-f7-ct-dec]')) change(key, Math.max(0, q - 1));
    });
    document.addEventListener('keydown', function(e){
      if (!el.classList.contains('is-open')) return;
      if (e.key === 'Escape') { doClose(); return; }
      if (e.key !== 'Tab') return;
      var f = [].filter.call(panel.querySelectorAll('a[href]:not([tabindex="-1"]),button:not([disabled]),input,select,textarea'), function(x){ return x.offsetParent !== null; });
      if (!f.length) { e.preventDefault(); panel.focus(); return; }
      var a = document.activeElement;
      if (e.shiftKey && (a === f[0] || a === panel)) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && (a === f[f.length - 1] || !panel.contains(a))) { e.preventDefault(); f[0].focus(); }
    });
    /* Ícone do cesto e qualquer link para /cart: abre a gaveta (fase de captura, para a gaveta do tema não abrir também) */
    document.addEventListener('click', function(e){
      if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || el.contains(a)) return;
      var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.origin !== location.origin || !CART_PATH.test(u.pathname) || CART_PATH.test(location.pathname)) return;
      e.preventDefault(); e.stopPropagation();
      lastFocus = a; openFresh();
    }, true);
    /* Outros scripts a mexer no cesto (combos, apps): manter a gaveta e os contadores em dia */
    var of = window.fetch;
    window.fetch = function(input){
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|update|clear)/.test(url)) p.then(function(){ setTimeout(function(){ refresh().catch(function(){}); }, 120); }).catch(function(){});
      return p;
    };
    document.addEventListener('cart:refresh', function(){ refresh().catch(function(){}); });
    window.addEventListener('pageshow', function(e){ if (e.persisted) refresh().catch(function(){}); });
    refresh().catch(function(){});
  };

  /* <cart-notification>: o product-form.js do tema chama estes métodos depois de adicionar */
  var API = {
    getSectionsToRender: function(){ return []; },
    setActiveElement: function(node){ lastFocus = node; },
    renderContents: function(){ openFresh(); },
    open: function(){ openFresh(); },
    close: function(){ doClose(); }
  };
  if (!customElements.get('cart-notification')) {
    customElements.define('cart-notification', class extends HTMLElement {
      connectedCallback(){ if (this.id === 'f7-cart') setup(this); }
      getSectionsToRender(){ return API.getSectionsToRender(); }
      setActiveElement(node){ API.setActiveElement(node); }
      renderContents(){ API.renderContents(); }
      open(){ API.open(); }
      close(){ API.close(); }
    });
  } else {
    /* Outro script já definiu <cart-notification>: os métodos vão direto para a instância */
    var node = document.getElementById('f7-cart');
    if (node) { Object.keys(API).forEach(function(k){ node[k] = API[k]; }); setup(node); }
  }
  if (!el) { var n2 = document.getElementById('f7-cart'); if (n2) setup(n2); }

  var safeRefresh = function(){ return refresh().catch(function(){ return cart; }); };
  window.F7Cart = { open: openFresh, close: doClose, refresh: safeRefresh, get: function(){ return cart; }, add: BN ? function(id){ return addVariant(id).then(openFresh); } : null, toast: toast };
  window.f7CartOpen = openFresh;
  if (typeof window.upcartOpenCart !== 'function') window.upcartOpenCart = openFresh;
  if (typeof window.upcartRefreshCart !== 'function') window.upcartRefreshCart = safeRefresh;
  if (typeof window.upcartGetCart !== 'function') window.upcartGetCart = function(){ return cart; };
})();
